import template from './chart-display.html';

const PREDEFINED_SIZES = {
	'small': ['320px', '550px'],
	'medium': ['400px', '690px'],
	'large': ['460px', '800px'],
	'extra-large': ['520px', '920px']
};

/*chart_options*
 * @kind component
 * @class ChartDisplayViewModel
 * @description Component for displaying a chart
 * @requirements  Chart_name or Chart_id [IF MORE THAN ONE CHART ON PAGE DEFINE CHART NUMBER as {chart_number: 1}], filter is also required
 */
class ChartDisplayViewModel
{
	constructor (params, element)
	{
		this.params = params;
		this.element = element;
		this.show_in_dialog = ko_helper.safe_observable(params.show_in_dialog || false);
		this.chart_size = ko_helper.safe_observable(params.chart_size || null);
		this.chart_height = ko_helper.safe_observable(params.chart_height || null);
		this.chart_width = ko_helper.safe_observable(params.chart_width || null);
		this.chart_name = ko_helper.safe_observable(params.chart_name);
		this.filters = ko_helper.safe_observable(params.filter || null);
		this.use_filter = ko_helper.safe_observable(params.use_filter || null);

		this.title = ko_helper.safe_observable(params.title);
		this.chart_display_count = ko_helper.safe_observable(params.chart_display_count || 0);
		this.chart = ko.observable();
		this.chart_options_loading = ko.observable(false);
		this.chart_options_not_loaded = ko.observable(false);
		this.chart_has_data = ko.observable(false);
		this.chart_exist = ko.observable(false);
		//UI-Fields`
		this.params_fields = ko.observableArray([]);
		this.params_inputs = ko.observable({});
		this.ui_fields = ko.observableArray([]);
		this.default_function_criteria = ko.observable({});
		this.show_filter = ko.observable(false);
		

		if (this.chart_size())
		{
			const presize = PREDEFINED_SIZES[this.chart_size()];
			if (presize)
			{
				if (!this.chart_height())
					this.chart_height(presize[0]);
				if (!this.chart_width())
					this.chart_width(presize[1]);
			}
		}

		this.init();

		this.filters.subscribe(() => { this.load_chart(); });

		this.chart_name.subscribe(() => { this.load_chart();});

		this.chart_display_count.subscribe(() => {this.load_chart();});
	}

	async init ()
	{	
		let request_obj = {
			schema: 'echarts',
			table: 'v_chart_info',
			filter: [{field: 'name', operand: '=', value: this.chart_name()}],
			limit: 1
		};
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status != 'OK'){
			Grape.toasts.message({ type: 'error', message: response.message});
			return;
		}
		if (response.records.length > 0){
			this.chart_exist(true)
		}
		await this.load_chart();
	}

	//TODO change this to something cleaner
	async get_var_value (variable)
	{
		// Create a temp element to apply the CSS var and get its computed value
		let temp_el = document.createElement('div');
		temp_el.style.cssText = `color: ${variable}; position: absolute; visibility: hidden;`;
		document.body.appendChild(temp_el);

		let computed_color = getComputedStyle(temp_el).color;
		document.body.removeChild(temp_el);

		return computed_color;
	}

	removeDuplicatesBySeriesId(array) {
		const seen = new Map();
		return array.filter(item => {
			const seriesId = item.seriesId;
			if (!seen.has(seriesId)) {
				seen.set(seriesId, true);
	  			return true;
			}
			return false;
  		});
	};

	async load_chart ()
	{
		if (!this.chart_exist())
			return;

		if (this.chart_name() == '')
			return;
		
		this.chart_options_loading(false);
		this.chart_has_data(false);
		this.chart_options_not_loaded(false);
		
		if (this.use_filter() && typeof this.filters() === 'undefined')
			return;

		try {
			let chartContainer = this.element.getElementsByClassName('ps-echarts-chart-element')[0];
			let my_chart = '';
			if (chartContainer)
			{
        		my_chart = echarts.getInstanceByDom(chartContainer);
        		if (my_chart)
          			my_chart.dispose(); // Dispose existing chart
        	}

			my_chart = echarts.init(chartContainer, null, {height: this.chart_height(), width: this.chart_width()});
			let chart_options = await Grape.fetches.getJSON('/api/echarts/chart/options', { chart_name: this.chart_name(), data_source_options: this.filters() });
			if (chart_options.legend === undefined)
			{
				Grape.toasts.message({ type: 'error', message: 'Chart options is undefined!'});
				this.chart_options_loading(false);
				this.chart_options_not_loaded(true);
				return;
			}
			//UI Fields
			this.ui_fields([]);
			this.params_fields([]);
			if (chart_options.data_source?.data_source_options?.ui_fields){
				this.ui_fields(chart_options.data_source.data_source_options.ui_fields);
			//	this.params_fields(chart_options.data_source.data_source_options.ui_fields);
				//this.load_ui_fields();
			}
			//Series UI fields
			if (chart_options.series){
				for (let series of chart_options.series){
					if (series.rowDataSourceOption?.uiField?.addToUiFields){
						let ui_field = {
							label: series.rowDataSourceOption.uiField.uiLabel,
							name: series.rowDataSourceOption.filter[0].field,
							type: 'text',
							operator: '=',
							default_value: series.rowDataSourceOption.filter[0].value,
							use_in: series.seriesId
						}
						this.ui_fields.push(ui_field);
					//	this.params_fields.push(ui_field);
					}
				}
			}
			if (this.ui_fields().length > 0)
				this.load_ui_fields();




			
			// Grid
			chart_options.grid = {
				containLabel: true
			};
			//ToDo check this 
				/*
				chart_options.grid = {
					containLabel: true,
					show: chart_options.grid[0]?.show || true,
					left: '10%',
					right: '10%'
				}
				*/
			// Legend
			let var_color;
			let text_color;
			if (chart_options.legend?.textStyleId)
			{
				let text_style_response = await Grape.fetches.getJSON('/api/echarts/chart/text/style', { text_style_id: chart_options.legend.textStyleId });
				var_color = text_style_response.color || '#fff';
			}
			text_color = var_color.startsWith('var') ? await this.get_var_value(var_color) : var_color;
			chart_options.legend.textStyle = {
				color: text_color
			};
			chart_options.legend.show = true;
			if (chart_options.legend.formatter)
				chart_options.legend.formatter = new Function('name', chart_options.legend.formatter);
			
			// Axes
			chart_options?.xAxis?.forEach(axis => {
				axis.axisLabel = {
					color: text_color
				}
				if (axis.layoutInfo?.labelFormatter)
					axis.axisLabel.formatter = new Function('value', axis.layoutInfo.labelFormatter);

				if (axis.layoutInfo?.labelRotate)
					axis.axisLabel.rotate = axis.layoutInfo.labelRotate.rotate;

				let offset_bottom = 0;
				let offset_top = 0;
				if (axis.position == 'bottom') {
					axis.offset = offset_bottom;
					offset_bottom = offset_bottom + 50;
				}else{
					axis.offset = offset_top;
					offset_top = offset_top + 50;
				}
			});

			chart_options?.yAxis?.forEach(axis => {
				axis.axisLabel = {
					color: text_color
				}
				if (axis.layoutInfo?.labelFormatter)
					axis.axisLabel.formatter = new Function('value', axis.layoutInfo.labelFormatter);

				if (axis.layoutInfo?.labelRotate)
					axis.axisLabel.rotate = axis.layoutInfo.labelRotate.rotate;

				let offset_left = 0;
				let offset_right = 50;
				if (axis.position == 'left') {
					axis.offset = offset_left;
					offset_left = offset_left + 50;
				}else{
					axis.offset = offset_right;
					offset_right = offset_right + 50;
				}
			});
			// Series
			chart_options.series.forEach(x => {
				//Label
				if (x.series_type_options?.label)
					x.label = x.series_type_options.label

				if (x.label?.formatter)
					x.label.formatter = new Function('value', x.label.formatter);
					
				if (x.series_type_options && x.series_type_options != ''){
					for ( const [key, value] of Object.entries(x.series_type_options)){
						if (key != '')
						x[key] = value;
					}
				}
				if (x.colorBy == 'data')
					delete x.color;

				if (x.type == 'pie')
					chart_options.emphasis = {'itemStyle': {'shadowBlur': 10,'shadowOffsetX': 0,'shadowColor': 'rgba(0, 0, 0, 0.5)'}}

				// ToDo Why ??
				if (x.name == 'Target' || x.name == 'Actual' || x.name == 'Job Creation' || x.name == 'Incidents')
				{
					x.barWidth = '20';
					x.label = {show: true,position: 'outside'};
				}
			});
			// Tool Tip
			chart_options.tooltip.formatter = (params) => {
				if (Array.isArray(params))
					params = this.removeDuplicatesBySeriesId(params);
				if (!params.length) params = [params];
				let seriesInfo = params.map((x) => {
					let value = x.data && x.data[1] !== undefined ? (x.seriesType === "pie" ? x.data[1] + '%' : x.data[1]) : "N/A";
					return x.marker + "" + (x.seriesName === '' ? x.name : x.seriesName) + " : " + value + "<br>";
				});
				return seriesInfo.join("");
			};
			// Dataset
			if (chart_options.dataset)
			{
				chart_options.dataset.forEach((dataset, index) => {
					if (dataset.source && dataset.source.length > 0)
						this.chart_has_data(true);
				});
			}
			//console.log(`chart-display --- chart_options --> ${JSON.stringify(chart_options)}`);
			if (this.chart_has_data() === true){
				my_chart.setOption(chart_options, { notMerge: true });
			}
			else
				my_chart.clear();

		} catch (error) {
			Grape.toasts.message({ type: 'error', message: error});
			this.chart_options_not_loaded(true);
		}

		this.chart_options_loading(false);
	}

	load_ui_fields(){
		if (this.filters().filter?.length > 0){
			for (let filter of this.filters().filter){
				for (const field of this.ui_fields()){
					if (filter.field == field.name)
						field.default_value = filter.value;
				}
			}
		}

		for (let f of this.ui_fields()){
			if (f.type == 'json'){
				f.default_value = JSON.stringify(f.default_value);
			}
			else if (f.type == 'list'){
				f.optionsText = 'name';
				f.optionsValue = 'value';
				if (f.list_options != ''){
					// is it a string in [] brackets
					if (/\[(.*?)\]/.test(f.list_options)){
						f.items = JSON.parse(f.list_options.replace(/'/g, '"'));
					}
					else
						f.items = f.list_options.split(',');
					}
					f.$input = f.default_value;
			}else if (f.type == 'lookup'){
				f.type = 'list';
				f.optionsText = 'name';
				f.optionsValue = f.list_value_field;
			}
		}
		this.params_fields(this.ui_fields());
		if (this.params_fields().length > 0){
			this.show_filter(true);
		}
	}

	reload_filters(){
		let filters = [];
		let series_filters = [];

		for (let [name, input] of Object.entries(this.params_inputs())){
			for (const field of this.ui_fields()){
				if (field.name == name){
					let filter = {
						field: field.name,
						operand: field.operator,
						use_in: field.use_in
					};
					switch(field.type){
						case 'json': {
							if (typeof (input()) === "object"){
								filter.value = input();
							}else{
								filter.value = JSON.parse(input());
							}
						//	filters.push(filter);
							break;
						}
						case 'list': {
							if (typeof (input()) === "object")
								filter.value = input()[field.optionsValue];
							else
								filter.value = input();
						//	filters.push(filter);
							break;
						}
						default: {
							filter.value = input();
						//	filters.push(filter);
						}
					}
					if (filter.use_in && filter.use_in > 0)
						series_filters.push(filter);
					else
						filters.push(filter);
				}	
			}
		}
		this.filters({filter: filters, series_filter: series_filters});
	}


}

export default {
	name: 'chart-display',
	viewModel: ChartDisplayViewModel,
	module_type: 'ko',
	template: template
};
